import ForgotEmail from './ForgotEmail';

export default ForgotEmail;
